import data from "../../../../../src/RelativeTime/RelativeTime.docs.json";
import * as React from 'react';
export default {
  data,
  React
};